import firebase from 'firebase'
import { LOAD_ESTATES } from '../actions'
import { LOAD_ESTATES_MUTATION } from '../mutations'
import { SHOW_ALERT } from '../actions'

const database = () => firebase.database ()


const state = {
	estates: [],
	selectedEstate: null,
	visibleEstates: {},
	loading: false,
	error: null
}

const actions = {
	[LOAD_ESTATES]: store => {
		store.commit (LOAD_ESTATES_MUTATION.REQUEST)

		database ()
			.ref ('estates')
			.once ('value')
			.then (data => {
				store.commit (LOAD_ESTATES_MUTATION.SUCCESS, data.val ())
			})
			.catch (err => {
				store.commit (LOAD_ESTATES_MUTATION.FAILURE, err)
			})
	},

	setEstateForSale: ({commit, dispatch}, estate) => {
		firebase.database ().ref ('estates').orderByChild ('token-id').equalTo (estate['token-id']). once ('value', function (value) {
			value.forEach (function (child) {
				firebase.database ().ref ('estates/' + child.key).update ({ for_sale: true }).then ( () => {

					dispatch ('loadWallet')
					commit (SHOW_ALERT, {
						text: 'Success!',
						message: `The Estate: <strong>"${estate.name}"</strong><br/> is now ready to be selled`,
						dismissable: true,
						actions: []
					})
					dispatch (LOAD_ESTATES)
					commit ('selectEstate', null)
				}).catch ( (error) => {
					console.log (error)
				})
			}) 
		})
	}
}

const mutations = {
	[LOAD_ESTATES_MUTATION.REQUEST]: state => {
		state.loading = true
	},

	[LOAD_ESTATES_MUTATION.SUCCESS]: (state, data) => {
		state.loading = false
		state.estates = data
	},

	[LOAD_ESTATES_MUTATION.FAILURE]: (state, error) => {
		state.loading = false
		state.error = error
	},

	selectEstate: (state, payload) => {
		state.selectedEstate = payload
	},

	showVisibileEstates: (state, payload) => {
		state.visibleEstates = payload
	}
}

const getters = {
	estates: state => state.estates,
	loadingEstates: state => state.loading,
	estatesTotalValue: ({ estates }) => {
		if (estates && estates.length) {
			const estatesPrice = estates.reduce ((totalCost, estate) => {
				totalCost += parseFloat (estate.buy_cost.replace (',', '.'))
				return totalCost
			}, 0)
			return estatesPrice
		}
		return 0
	},
	estatesForSale: state => state.estates.filter ((estate) => estate.for_sale)
}

export default {
	state,
	actions,
	mutations,
	getters
}